// Paleta e identidad de "TuRastreo Logística".
// Azul de rastreo + violeta OBD sobre fondo navy profundo, estilo promocional.

export const COLORS = {
  bg: "#0A1220",
  bgAlt: "#0E1A2B",
  panel: "#122236",
  ink: "#EAF2FA",
  sub: "#9DB1C6",
  blue: "#2B6CB0",
  blueLight: "#5FA0E4",
  purple: "#7C5CBF",
  purpleLight: "#AF95E6",
  green: "#2E8B57",
  greenLight: "#5BC489",
  amber: "#E9B44C",
  red: "#E05A45",
  white: "#FFFFFF",
} as const;

export const NEUTRAL = {
  line: "rgba(255,255,255,0.08)",
  lineStrong: "rgba(255,255,255,0.16)",
  glassBg: "rgba(255,255,255,0.05)",
};

export const FONT =
  '"Segoe UI", system-ui, -apple-system, Roboto, "Helvetica Neue", Arial, sans-serif';

export const FONT_MONO =
  'ui-monospace, "SF Mono", "Segoe UI Mono", Menlo, Consolas, monospace';

export const VIDEO = {
  width: 1920,
  height: 1080,
  fps: 30,
} as const;

export const SAFE = 150;
